import { useState } from 'react';
import { Modal, ModalBody, ModalFooter, Button, ModalHeader } from 'src/components/ui';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import useResourceLoader from '../../util/useResourceLoader';
import UWEEntityApi from '../../api/UWEEntityApi';
import { getTestId } from '../../hooks/useTestId';

const PARAMS = ['formData'];

function SendBackModalFinalApproval({
  formData,
  formContext,
  onConfirm: onClose,
  isOpen,
  scope: {
    props: { currentEntity },
  },
  testIdBase = 'send-back-final-modal',
}) {
  const {
    setFormDataValues,
  } = formContext;

  const [error, setError] = useState('');

  const id = currentEntity?.id;

  const [assignmentByRoleIdMap, loadingAssignments, errorRole, setAssignmentByRoleIdMap] = useResourceLoader(
    async () => (await UWEEntityApi.getUWEEntityAssignments({ id }))
      .assignments.reduce((_, x) => {
        _[x.roleId] = x;

        return _;
      }, {}),
    [id],
    []
  );

  const [rejectReason, setRejectReason] = useState('');
  const [rejectRole, setRejectRole] = useState('');

  function onChange({ target: { value } }) {
    setError('');
    setRejectReason(value);
  }

  function onAccept(e) {
    e.stopPropagation();

    if (!rejectRole) {
      setError(t`You must select a role`);
    } else if (!rejectReason) {
      setError(t`You must enter a send-back reason`);
    } else {
      formData.sendBackReason = rejectReason;
      formData.sendBackTo = rejectRole;
      onClose(true);
    }
  }

  function onChangeRole({ target }) {
    const { value } = target;
    setError('');
    setRejectRole(value);
  }


  return (
    <Modal isOpen={isOpen}
      toggle={() => onClose()}
      className="modal-primary"
      size='xl'
      backdrop
    >
      <ModalHeader
        toggle={() => onClose()}
      >
        <Trans>Send Back Final Requisition</Trans>
      </ModalHeader>
      <ModalBody>
        <>
          <div className="row">
            <div className="col-lg-12">
              <span className="text-danger">{error}</span>
              <div className="form-group">
                <label className="title"><Trans>Send back to:</Trans></label>
                <select value={rejectRole} className="form-control" onChange={e => onChangeRole(e)} {...getTestId(testIdBase, '.', 'role-select')}>
                  <option value="" disabled>
                    ----
                  </option>
                  {Object.values(assignmentByRoleIdMap).map((item, idx) => (
                    <option key={idx} value={item.role.name}>
                      {item.user.name} ({item.role.name})
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label className="title"><Trans>Reason:</Trans></label>
                <textarea rows={4} value={rejectReason || ''} className="form-control" name="description" onChange={e => onChange(e)} {...getTestId(testIdBase, '.', 'reason')} />
              </div>
            </div>
          </div>
        </>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onAccept} color="primary" {...getTestId(testIdBase, '.', 'confirm')}>
          <Trans>Confirm</Trans>
        </Button>
        <Button onClick={() => onClose()} color="secondary" {...getTestId(testIdBase, '.', 'close')}>
          <Trans>Close</Trans>
        </Button>
      </ModalFooter>
    </Modal>
  );
}

SendBackModalFinalApproval.PARAMS = PARAMS;

export default SendBackModalFinalApproval;
